import { api } from 'api/api'
import { z } from 'zod'

const intercomJwtResponseSchema = z.object({
  jwt: z.string(),
})

export async function getIntercomJwt() {
  const response = await api.get('/intercom/jwt')
  const data = intercomJwtResponseSchema.parse(response.data)
  return data.jwt
}
